export default __webpack_public_path__ + "static/media/product-2.252bd24a.webp";